/* eslint-disable no-case-declarations */
/* eslint-disable no-use-before-define */
/* eslint-disable global-require */
/* eslint-disable no-multi-assign */
/* eslint-disable no-return-assign */
/* eslint-disable no-param-reassign */
/* eslint-disable no-constant-condition */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/jsx-props-no-multi-spaces */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-console */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-undef */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-debugger */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {
    useEffect, useCallback, useState, useContext, useRef,
} from 'react';
import Modal from 'react-modal';
import { useParams, Link } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { Buffer } from 'buffer';
import { uploadFile } from 'react-s3';
import {
    GlobalDistributorPrevileges, CategoryDistributorPrevileges, threePL,
} from '../../constants';
import { CamelCase, PriceHandler, TitleCase } from '../../redux/helper/CamelCase';
import { distributorService } from '../../service/distributor.service';
import { userService } from '../../service/user.service';
import TableHeader from '../../TableHeader';
import ThreeDotsLoader from '../../Components/LoadingDots';
import CustomToast from '../../Components/AlertPopup';
import DistributorHeder from './DistributorHeder';
import DistributoSkeleton from './DistributorSkeleton';
import ProductsModal from './DistrubutorModals/ProductsModal';
import RolesModal from './DistrubutorModals/RolesModal';
import RemovePopup from './DistrubutorModals/RemovePopup';
import HeaderContext from '../../Components/Context/HeaderContext';
import { InitialIcon } from '../../redux/helper/IconGenerator';
import { InitialMaker } from '../../redux/helper/InitialMaker';
import { history } from '../../redux/helper';
import { FileUpload } from '../../redux/helper/fileUpload';
import AdorLoader from '../../redux/helper/AdorLoader';
import { Certificateconfig } from '../../Components/config';
import { AccessPrevilegesFunction } from '../../constants/GlobalAccessFunction';

window.Buffer = window.Buffer || require('buffer').Buffer;

const spring = {
    type: 'spring',
    stiffness: 700,
    damping: 30,
};

function ViewDistributor({ isUpdate }) {
    const uploadprevilegeassigned = AccessPrevilegesFunction('distributor:upload_certificate');
    const assignmentprevilegeassigned = AccessPrevilegesFunction('distributor:assignment');

    const certificateRef = useRef('');
    const [isLoaded, setisLoaded] = useState(false);
    const [DistributorData, setDistributorData] = useState([]);
    const [addresses, setAddresses] = useState([]);
    const [TwoTabs, setTwoTabs] = useState('address');
    const [PrivilegeTab, setPrivilegeTab] = useState('global');
    const [SavedPrivileges, setSavedPrivileges] = useState({ PRIVILAGES: [], CATEGORY_PRIVILAGES: { IWB: [], MnR: [] } });
    const [thriPL, setthriPL] = useState([]);
    const [ThreePlOpen, setThreePlOpen] = useState('');
    const [Products, setProducts] = useState([]);
    const { id } = useParams();
    const [ModalType, setModalType] = useState('');
    const [loading, setloading] = useState(false);
    const [title, settitle] = useState('');
    const [color, setcolor] = useState(false);
    const [render, setrender] = useState(false);
    const [spinner, setspinner] = useState(false);
    const {
        isPopup,
        setisPopup,
        ErrorMessage,
        SetErrorMessage,
        SuccessMessage,
        SetSuccessMessage,
        colorValue,
        setcolorValue,
        setHardRefresh,
        setHasUnsavedChanges,
        setSaveHandler,
        requestNavigation,
    } = useContext(HeaderContext);
    const [rolesParams, setrolesParams] = useState({
        type: '',
        search: '',
        shortcut: '',
    });
    const [removeParams, setremoveParams] = useState({
        type: '',
        shortcut: '',
        bh: [],
    });
    const [PopupRoles, setPopupRoles] = useState([]);
    const getDistributorDetails = useCallback(
        async () => {
            const resdata = await distributorService.getDistributorDetail(id);
            if (!resdata.error && resdata.data.success_status) {
                setHardRefresh(false);
                const resp = resdata.data.data;
                const rolesObject = {
                    sales_head: [], regional_sales_manager: [], area_sales_engineer: [], area_sales_manager: [],
                };
                if (resp.SUPPORTS.length > 0) {
                    resp.SUPPORTS.forEach((support) => {
                        const role = support.ROLES.toLowerCase().replace('business', 'sales').replaceAll(' ', '_');
                        rolesObject[role].push(support);
                    });
                    resp.TEMP_SUPPORT = rolesObject;
                } else {
                    resp.TEMP_SUPPORT = rolesObject;
                }
                resp.CATEGORY_PRIVILAGES = resp.CATEGORY_PRIVILAGES || { IWB: [], MnR: [] };
                setSavedPrivileges({
                    PRIVILAGES: [...resp.PRIVILAGES],
                    CATEGORY_PRIVILAGES: {
                        IWB: [...(resp.CATEGORY_PRIVILAGES.IWB || [])],
                        MnR: [...(resp.CATEGORY_PRIVILAGES.MnR || [])],
                    },
                });
                distributorService.getDistributorAddress(resdata?.data?.data.CUST_ACCOUNT_ID).then((res1) => {
                    if (!res1.error && res1.data.success_status) {
                        setAddresses(res1?.data?.data);
                    }
                });
                setDistributorData(resp);
                setisLoaded(true);
            } else {
                SetErrorMessage(resdata.message);
                setcolorValue(!colorValue);
                setTimeout(() => {
                    SetErrorMessage('');
                    setcolorValue(!colorValue);
                    window.location.href = '/distributors';
                }, 3000);
            }
            const prod = await userService.getProducts();
            if (prod.data.data.length > 0) {
                const arr = [];
                prod.data.data.forEach((mng, i) => {
                    arr.push({
                        id: `prod-${i}`, label: mng.MAIN_CATEGORY,
                    });
                });
                setProducts(arr);
            }
            const threepl = await distributorService.getNewthreepl();
            if (threepl.data.data.length > 0) {
                setthriPL(threepl.data.data);
            }
        },
        [id],
    );

    useEffect(() => {
        getDistributorDetails();
    }, [getDistributorDetails]);
    const find3pl = (key) => thriPL.length > 0 && thriPLer((name) => name.OPERATING_UNIT_ID === key);

    const checkExist = (key) => DistributorData.SUPPORTS.filter((val) => val.ROLES === key);
    const customStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
        },
    };
    function closeModal() {
        setModalType('');
    }
    function Message() {
        return (
            <p className=" text-[#000000] text-center font-medium pl-5 py-3" style={{ fontSize: '15px', color: '#808285' }}>
                {title}
            </p>
        );
    }
    const HandleCertificateUpdate = async (key, copy) => {
        setloading(true);
        setThreePlOpen('');
        const payload = DistributorData;
        payload.ACCOUNT_NUMBER = undefined;
        payload.LAST_UPDATE_DATE = undefined;
        const payloadcopy = {};

        Object.keys(payload).forEach((item) => {
            if (item === 'LAST_UPDATE_DATE,') {
                delete payload[item];
            } else {
                payloadcopy[item] = payload[item];
            }
        });
        const res = await distributorService.UpdateDistributor(id, payloadcopy);
        if (!res.error && res.data.success_status) {
            // setDistributorData(res.data.data);
            settitle(`Certificate ${key} Successfully!`);
            if (copy) {
                setDistributorData(copy);
                setshowRemoveCertificate('');
            }
            setModalType('');
            setloading(false);
            setThreePlOpen('');
            setTimeout(() => {
                settitle('');
            }, 4000);
            setspinner(false);
            setrender(!render);
        } else {
            settitle('Error occured while updating');
            setcolor(true);
            setModalType('');
            setTimeout(() => {
                settitle('');
                setcolor(false);
            }, 4000);
            setspinner(false);
        }
    };
    const HandleUpdate = async (itemchange, key) => {
        setloading(true);
        setThreePlOpen('');
        let payload = DistributorData;
        if (itemchange && key) {
            payload[key] = itemchange;
        }
        if (itemchange && key === undefined) {
            payload = itemchange;
        }
        payload.ACCOUNT_NUMBER = undefined;
        payload.LAST_UPDATE_DATE = undefined;
        const payloadcopy = {};

        Object.keys(payload).forEach((item) => {
            if (item === 'LAST_UPDATE_DATE,') {
                delete payload[item];
            } else {
                payloadcopy[item] = payload[item];
            }
        });
        const res = await distributorService.UpdateDistributor(id, payloadcopy);
        if (!res.error && res.data.success_status) {
            if (itemchange && key) {
                payload[key] = itemchange;
                const disArr = { ...DistributorData };
                const disVal = [...disArr[key]];
                disVal[key] = itemchange;
                const rolesObject = {
                    sales_head: [], regional_sales_manager: [], area_sales_engineer: [], area_sales_manager: [],
                };
                if (disArr.SUPPORTS.length > 0) {
                    disArr.SUPPORTS.forEach((support) => {
                        const role = support.ROLES.toLowerCase().replace('business', 'sales').replaceAll(' ', '_');
                        rolesObject[role].push(support);
                    });
                    disArr.TEMP_SUPPORT = rolesObject;
                } else {
                    disArr.TEMP_SUPPORT = rolesObject;
                }
                setDistributorData(disArr);
            }
            if (itemchange && key === undefined) {
                setDistributorData(itemchange);
            }
            if (itemchange === undefined && key === undefined) {
                settitle('Distributors privileges has been Updated sucessfully!');
            }
            switch (ModalType) {
            case 'products':
                settitle('Product Categories Updated Successfully!');
                break;
            case 'remove':
                const role1 = rolesParams.type.split('_').map((a) => a.charAt(0).toUpperCase() + a.substr(1));
                const message1 = `${role1.join(' ').replace('Sales', 'Business')} (${rolesParams.shortcut}) has been removed sucessfully!`;
                settitle(message1);
                break;
            case 'rolesModal':
                const role = rolesParams.type.split('_').map((a) => a.charAt(0).toUpperCase() + a.substr(1));
                const message = `${role.join(' ').replace('Sales', 'Business')} (${rolesParams.shortcut}) added sucessfully!`;
                settitle(message);
                break;
            default: break;
            }
            setModalType('');
            setloading(false);
            setThreePlOpen('');
            setTimeout(() => {
                settitle('');
            }, 4000);
            getDistributorDetails();
            setrender(!render);
            return true;
        }
        settitle('Error occured while updating');
        setcolor(true);
        setModalType('');
        setloading(false);
        setTimeout(() => {
            settitle('');
            setcolor(false);
        }, 4000);
        return false;
    };
    const handleAddPrevilage = (item, keys) => {
        const copyArr = { ...DistributorData };
        const arr = [...copyArr[keys]];
        const index = arr.indexOf(item);
        if (index > -1) {
            arr.splice(index, 1);
        } else {
            arr.push(item);
            // 'ador_cash_debit'/'ador_cash_credit' (global) and 'cash_discount' (category) are mutually exclusive
            if (item === 'ador_cash_debit' || item === 'ador_cash_credit') {
                const categoryPrivilages = { ...copyArr.CATEGORY_PRIVILAGES };
                ['IWB', 'MnR'].forEach((category) => {
                    categoryPrivilages[category] = (categoryPrivilages[category] || []).filter((priv) => priv !== 'cash_discount');
                });
                copyArr.CATEGORY_PRIVILAGES = categoryPrivilages;
            }
        }
        copyArr[keys] = arr;
        setDistributorData(copyArr);
    };
    const handleToggleCategoryPrevilage = (item, category) => {
        const copyArr = { ...DistributorData };
        const categoryPrivilages = { ...copyArr.CATEGORY_PRIVILAGES };
        const arr = [...(categoryPrivilages[category] || [])];
        const index = arr.indexOf(item);
        if (index > -1) {
            arr.splice(index, 1);
        } else {
            arr.push(item);
            // 'ador_cash_debit'/'ador_cash_credit' (global) and 'cash_discount' (category) are mutually exclusive
            if (item === 'cash_discount') {
                copyArr.PRIVILAGES = copyArr.PRIVILAGES.filter((priv) => priv !== 'ador_cash_debit' && priv !== 'ador_cash_credit');
            }
        }
        categoryPrivilages[category] = arr;
        copyArr.CATEGORY_PRIVILAGES = categoryPrivilages;
        setDistributorData(copyArr);
    };
    const getRolesDetails = useCallback(
        async () => {
            const roleDetail = await distributorService.GetRoleDetails(CamelCase(rolesParams?.type?.replace(/\s/g, '_').replace('Business', 'sales')), rolesParams.search);
            if (roleDetail.data?.success_status && roleDetail.data.data.Items.length > 0) {
                setPopupRoles(roleDetail.data.data.Items);
            } else {
                setPopupRoles([]);
            }
        },
        [rolesParams],
    );
    useEffect(() => {
        getRolesDetails();
    }, [getRolesDetails]);

    useEffect(() => {
        if (ModalType !== '') {
            setisPopup(true);
        } else {
            setisPopup(false);
            setPopupRoles([]);
        }
    }, [ModalType]);
    const [showRemoveCertificate, setshowRemoveCertificate] = useState('');
    const handleImageChange = async (e) => {
        const files = certificateRef.current?.files;
        // make sure that it's not null or undefined
        setspinner(true);

        if (files.length === 0) {
            return;
        }
        uploadFile(files[0], Certificateconfig)
            .then((data) => {
                const distributorsCopy = { ...DistributorData };
                distributorsCopy.DISTRIBUTOR_CERTIFICATE.push(data.key);
                setDistributorData(distributorsCopy);
                HandleCertificateUpdate('Uploaded');
            })
            .catch((err) => {
                setspinner(false);

                return err;
            });

        // need to set something
    };
    const handleRemoveCerificate = (idx) => {
        if (isUpdate) {
            setspinner(true);
            const distributorsCopy = { ...DistributorData };
            distributorsCopy.DISTRIBUTOR_CERTIFICATE.splice(idx, 1);
            HandleCertificateUpdate('removed', distributorsCopy);
        }
    };
    const handleRefClick = () => {
        /* Collecting node-element and performing click */
        certificateRef.current.click();
    };

    const capitalizeFirstLetter = (string) => string.split('_').reduce((final, element) => (`${final.charAt(0).toUpperCase() + final.slice(1)} ${element.charAt(0).toUpperCase() + element.slice(1)}`));

    const capitalizeFirstChracter = (string) => {
        let finalString = '';
        string.split('_').forEach((final) => {
            finalString += final.charAt(0).toUpperCase();
        });
        return finalString;
    };

    const formatPrivilegeName = (item) => {
        if (item === 'credit_debit:list') {
            return 'Credit/Debit Details';
        }
        if (item === 'place_eub_order') {
            return 'Place EUB Order';
        }
        return TitleCase(CamelCase(item.replace(/_/g, ' ')));
    };

    const arraysEqualAsSets = (a = [], b = []) => a.length === b.length && a.every((item) => b.includes(item));
    const isPrivilegesDirty = isLoaded && (
        !arraysEqualAsSets(DistributorData.PRIVILAGES, SavedPrivileges.PRIVILAGES)
        || !arraysEqualAsSets(DistributorData.CATEGORY_PRIVILAGES?.IWB, SavedPrivileges.CATEGORY_PRIVILAGES.IWB)
        || !arraysEqualAsSets(DistributorData.CATEGORY_PRIVILAGES?.MnR, SavedPrivileges.CATEGORY_PRIVILAGES.MnR)
    );

    useEffect(() => {
        const handleBeforeUnload = (e) => {
            if (isPrivilegesDirty) {
                e.preventDefault();
                e.returnValue = '';
            }
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => window.removeEventListener('beforeunload', handleBeforeUnload);
    }, [isPrivilegesDirty]);

    useEffect(() => {
        setHasUnsavedChanges(isPrivilegesDirty);
    }, [isPrivilegesDirty]);

    useEffect(() => () => setHasUnsavedChanges(false), []);

    useEffect(() => {
        setSaveHandler(() => () => HandleUpdate());
        return () => setSaveHandler(null);
    });

    const handleBackClick = (e) => {
        if (isPrivilegesDirty) {
            e.preventDefault();
            requestNavigation('/distributors');
        }
    };

    return (
        <>
            <div className="flex items-center pb-6">
                <Link to="/distributors" onClick={handleBackClick}>
                    <img src="/images/Icon-feather-arrow-left.svg" alt="icon" />
                </Link>
                {isUpdate ? (
                    <p className="text-xs4 font-normal text-[#555259] pl-4">
                        Edit Distributor
                    </p>
                ) : (
                    <p className="text-xs4 font-normal text-[#555259] pl-4">
                        View Distributor
                    </p>
                )}
            </div>

            <Modal
                style={customStyles}
                isOpen={ModalType !== '' && isUpdate}
                onRequestClose={closeModal}
            >
                {
                    ModalType === 'products' && (
                        <ProductsModal
                            Products={Products}
                            setModalType={setModalType}
                            DistributorData={DistributorData}
                            setDistributorData={setDistributorData}
                            HandleUpdate={HandleUpdate}
                            loading={loading}
                            setloading={setloading}
                        />

                    )
                }
                {
                    ModalType === 'rolesModal' && (
                        <RolesModal
                            rolesParams={rolesParams}
                            setModalType={setModalType}
                            PopupRoles={PopupRoles}
                            setrolesParams={setrolesParams}
                            DistributorData={DistributorData}
                            setDistributorData={setDistributorData}
                            handleUpdate={HandleUpdate}
                            loading={loading}
                            capitalizeFirstLetter={capitalizeFirstLetter}
                            setloading={setloading}
                        />
                    )
                }
                <>
                    {ModalType === 'remove' && (
                        <RemovePopup
                            DistributorData={DistributorData}
                            removeParams={removeParams}
                            setModalType={setModalType}
                            handleUpdate={HandleUpdate}
                            loading={loading}
                            setloading={setloading}
                        />
                    )}

                </>
            </Modal>
            <>
                {title !== '' && (
                    <CustomToast
                        open
                        color={color ? '#ED1C24' : undefined}
                        message={<Message />}
                    />
                )}

            </>
            <div className="">
                {isLoaded ? <DistributorHeder isLoaded={isLoaded} Details={DistributorData} /> : <DistributoSkeleton />}
                {isLoaded && (
                    <div className="flex">
                        <AnimatePresence>
                            <motion.div
                                key={isLoaded}
                                animate={{ opacity: 1, y: 0 }}
                                initial={{ opacity: 0, y: 20 }}
                                exit={{ opacity: 0, y: -20 }}
                                transition={{ duration: 0.15 }}
                                className=""
                            >
                                <div className="flex">
                                    <div className="bg-[#F5F5FA] rounded-[7px] mt-[27px] pt-4 pl-4 pr-4 pb-3 mr-2 relative" style={{ marginRight: '29px' }}>
                                        <div className="flex justify-center flex-col items-center">
                                            <span className="text-xs9 font-normal text-[#555259]">Type</span>
                                            <p className="text-xs4 font-normal text-[#090406] mt-3">{DistributorData.ATTRIBUTE3}</p>
                                        </div>
                                    </div>
                                    {uploadprevilegeassigned
                                    && (
                                        <div className="bg-[#F5F5FA] rounded-[7px] mt-[27px] pt-4 pl-4 pr-4 pb-3 mr-2 relative" style={{ width: '208px' }}>

                                            <p className="text-xs9 font-normal text-[#555259]">Certificate</p>
                                            {!spinner ? (
                                                <div className="flex items-center  flex-wrap">
                                                    {(DistributorData?.DISTRIBUTOR_CERTIFICATE.length === 0 && !isUpdate) ? <div className="pl-[25px]">-</div>
                                                        : (
                                                            <ul className="flex mt-2">
                                                                {
                                                                    DistributorData?.DISTRIBUTOR_CERTIFICATE.length > 0 && DistributorData.DISTRIBUTOR_CERTIFICATE.map((certificate, idx) => (
                                                                        <>
                                                                            {idx === 0
                                                                && (
                                                                    <li className="text-xs6 font-normal text-[#090406] bg-[#FFFFFF] px-2.5 py-1.5 w-fit cursor-pointer rounded-[7px] flex mr-2 break-all" key={idx}>
                                                                        {certificate.split('/')[certificate.split('/').length - 1]}
                                                                        <img
                                                                            src="/images/Group8554.svg"
                                                                            alt="icon"
                                                                            className="mr-2.5 ml-1 remove-rec"
                                                                            onClick={() => {
                                                                                setshowRemoveCertificate(idx);
                                                                                handleRemoveCerificate();
                                                                            }}
                                                                        />
                                                                    </li>
                                                                )}

                                                                        </>

                                                                    ))
                                                                }

                                                            </ul>
                                                        )}
                                                    {isUpdate && showRemoveCertificate === '' && DistributorData.DISTRIBUTOR_CERTIFICATE.length === 0 && (
                                                        <div className="cursor-pointer mt-3 ml-6 flex change-re">
                                                            <input
                                                                type="file"
                                                                name="upload"
                                                                id="add"
                                                                className="hidden w-full"
                                                                ref={certificateRef}
                                                                onChange={(e) => {
                                                                    handleImageChange(e);
                                                                }}
                                                            />
                                                            <img src="/images/add.svg" alt="icon" className="cursor-pointer mr-1" onClick={() => handleRefClick()} />
                                                            <label htmlFor="add" className="text-xs font-bold text-[#555259] cursor-pointer">Upload Certificate</label>
                                                        </div>
                                                    )}

                                                </div>
                                            ) : (
                                                <div className="loader">
                                                    {' '}
                                                    <AdorLoader />
                                                </div>
                                            )}

                                        </div>
                                    ) }
                                    <div className="bg-[#F5F5FA] rounded-[7px] w-fit mt-[27px] pt-4 pl-4 pr-4 pb-3 flex" style={{ marginLeft: '29px' }}>
                                        <div style={{ marginRight: '29px' }}>
                                            <div className="flex">
                                                <p className="text-xs9 font-normal text-[#555259]">Product Category(s)</p>
                                                <button type="button" data-bs-toggle="modal" data-bs-target="#exampleModalCenter">
                                                    {Products.length > 0 && isUpdate && (<img src="/images/edit-2.svg" alt="icon" className="pl-2.5" onClick={() => setModalType('products')} />)}
                                                </button>
                                            </div>
                                            {((DistributorData.PRODUCT_CATEGORIES).length === 0 && !isUpdate) ? <div className="pl-[55px]">-</div>
                                                : (
                                                    <ul className="pt-2.5 flex flex-wrap">
                                                        {DistributorData.PRODUCT_CATEGORIES.map((item, i) => (
                                                            <li key={item} className={`text-xs6 font-normal text-[#090406] bg-[#FFFFFF] px-2.5 py-1.5 w-fit cursor-pointer mb-1 rounded-[7px] ${i !== 0 && 'ml-2'}`}>{item}</li>

                                                        ))}

                                                    </ul>
                                                )}
                                        </div>
                                    </div>
                                </div>

                            </motion.div>
                        </AnimatePresence>
                    </div>
                )}
                {isLoaded && (
                    <AnimatePresence>
                        <motion.div
                            key={isLoaded}
                            animate={{ opacity: 1, y: 0 }}
                            initial={{ opacity: 0, y: 20 }}
                            exit={{ opacity: 0, y: -20 }}
                            transition={{ duration: 0.15 }}
                        >
                            <div className="mt-10 flex">
                                <div className="rounded-lg border border-[#EBEBEB] bg-[#FFFFFF] shadow-s6 pl-[15px] pt-[15px] pr-6 pb-2.5 w-1/3">
                                    <p className="text-xs6 font-normal text-[#090406]">Credit Limit</p>
                                    <p className="text-lg font-semibold text-[#090406]">
                                        {PriceHandler(DistributorData?.OVERALL_CREDIT_LIMIT ? DistributorData.OVERALL_CREDIT_LIMIT : 0)}
                                    </p>
                                </div>
                                <div className="rounded-lg border border-[#EBEBEB] bg-[#FFFFFF] shadow-s6 pl-[15px] pt-[15px] pr-6 pb-2.5 w-1/3 ml-[30px]">
                                    <p className="text-xs6 font-normal text-[#090406]">Pending Order Value</p>
                                    <p className="text-lg font-semibold text-[#090406]">
                                        {(DistributorData?.pending_order_value) && (DistributorData?.pending_order_value !== null) ? PriceHandler(DistributorData?.pending_order_value) : PriceHandler(0) }
                                    </p>
                                </div>
                                <div className="rounded-lg border border-[#EBEBEB] bg-[#FFFFFF] shadow-s6 pl-[15px] pt-[15px] pr-6 pb-2.5 w-1/3 ml-[30px]">
                                    <p className="text-xs6 font-normal text-[#090406]">Credit Balance</p>
                                    <p className="text-lg font-semibold text-[#090406]">
                                        {(DistributorData?.CREDIT_BALANCE) && (DistributorData?.CREDIT_BALANCE !== null) ? PriceHandler(DistributorData?.CREDIT_BALANCE) : 0 }
                                    </p>
                                </div>
                                <div className="rounded-lg border border-[#EBEBEB] bg-[#FFFFFF] shadow-s6 pl-[15px] pt-[15px] pr-6 pb-2.5 w-1/3 ml-[30px]">
                                    <p className="text-xs6 font-normal text-[#090406]">Outstanding Amount</p>
                                    <p className="text-lg font-semibold text-[#090406]">
                                        {(DistributorData?.OUTSTANDING_AMT) && (DistributorData?.OUTSTANDING_AMT !== null) ? PriceHandler(DistributorData.OUTSTANDING_AMT) : 0 }
                                    </p>
                                </div>
                                <div className="rounded-lg border border-[#EBEBEB] bg-[#FFFFFF] shadow-s6 pl-[15px] pt-[15px] pr-6 pb-2.5 w-1/3 ml-[30px]">
                                    <p className="text-xs6 font-normal text-[#090406]">Overdue Amount</p>
                                    <p className="text-lg font-semibold text-[#090406]">
                                        {(DistributorData?.TOTAL_OVERDUE_AMT) && (DistributorData?.TOTAL_OVERDUE_AMT !== null) ? PriceHandler(DistributorData?.TOTAL_OVERDUE_AMT) : 0 }
                                    </p>
                                </div>
                            </div>
                        </motion.div>
                    </AnimatePresence>
                )}
                {isLoaded && (
                    <div className="flex">
                        <div className="mt-10 px-10 pt-[26px] bg-[#F5F5FA] rounded-[7px] w-[70%]">
                            <ul className="nav nav-pills flex border-b border-[#FFFFFF]" id="pills-tab" role="tablist">
                                <li className="nav-item" role="presentation" onClick={() => setTwoTabs('address')}>
                                    <a
                                        href="javascript:void(0)"
                                        className={`nav-link block text-xs10 font-normal text-[#555259] ${TwoTabs === 'address' ? 'active' : ''} regadd pb-3.5 relative`}
                                        id="pills-regAddress-tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-regAddress"
                                        role="tab"
                                        aria-controls="pills-regAddress"
                                        aria-selected="true"
                                    >
                                        Registered Address
                                    </a>
                                </li>
                                {assignmentprevilegeassigned
                                && (
                                    <li className="nav-item pl-[130px]" role="presentation">
                                        <a
                                            href="javascript:void(0)"
                                            onClick={() => {
                                                setTwoTabs('liasions');
                                            }}
                                            className={`nav-link block text-xs10 font-normal ${TwoTabs === 'liasions' ? 'active' : ''} text-[#555259] regadd pb-3.5 relative`}
                                            id="pills-ador-tab"
                                            data-bs-toggle="pill"
                                            data-bs-target="#pills-ador"
                                            role="tab"
                                            aria-controls="pills-ador"
                                            aria-selected="true"
                                        >
                                            Ador Support
                                        </a>
                                    </li>
                                )}
                            </ul>
                            <div className="tab-content" id="pills-tabContent">
                                <div className={`tab-pane fade ${TwoTabs === 'address' ? 'show active' : 'hidden'} pt-[30px] pb-[140px]`} id="pills-regAddress" role="tabpanel" aria-labelledby="pills-regAddress-tab">
                                    <div className="flex">
                                        <div className="w-1/2 pr-[30px]">
                                            <AnimatePresence exitBeforeEnter>
                                                <motion.div
                                                    key={TwoTabs === 'address'}
                                                    animate={{ opacity: 1, y: 0 }}
                                                    initial={{ opacity: 0, y: 20 }}
                                                    exit={{ opacity: 0, y: -20 }}
                                                    transition={{ duration: 0.15 }}
                                                >
                                                    <p className="text-lg font-normal text-[#555259]">Billing Address</p>

                                                    {addresses.length > 0
                                                        ? (isLoaded && addresses.length > 0 && addresses.filter((addr) => addr.SITE_USE_CODE === 'BILL_TO').map((value, i) => (
                                                            <div className="rounded-[7px] bg-[#FFFFFF] px-7 pt-3 pb-3.5 mt-5" key={i}>
                                                                {/* <p className="text-xs6 font-normal text-[#808285]">Office Main</p> */}
                                                                <p className="pt-4 text-xs6 font-normal text-[#090406]">
                                                                    {value.ADDRESS1}
                                                                    {' '}
                                                                    {value.ADDRESS2}
                                                                    ,
                                                                    <br />
                                                                    {' '}
                                                                    {value.ADDRESS3}
                                                                    {' '}
                                                                    {value.ADDRESS4}
                                                                    ,
                                                                    <br />
                                                                    {' '}
                                                                    {value.CITY}
                                                                    {' '}
                                                                    -
                                                                    {' '}
                                                                    {value.POSTAL_CODE}
                                                                    {' '}
                                                                    {value.STATE}
                                                                    ,
                                                                    {' '}
                                                                    {value.COUNTRY}
                                                                    ,
                                                                    <br />
                                                                    {' '}
                                                                    {value.LOCATION}
                                                                    <br />
                                                                    {' '}
                                                                    {value.ATTRIBUTE2}
                                                                </p>
                                                            </div>
                                                        )))
                                                        : <div className="pt-5 font-semi-bold text-lg">No Billing Address Available</div>}
                                                </motion.div>
                                            </AnimatePresence>
                                        </div>
                                        <div className="w-1/2">
                                            <AnimatePresence exitBeforeEnter>
                                                <motion.div
                                                    key={TwoTabs === 'address'}
                                                    animate={{ opacity: 1, y: 0 }}
                                                    initial={{ opacity: 0, y: 20 }}
                                                    exit={{ opacity: 0, y: -20 }}
                                                    transition={{ duration: 0.15 }}
                                                >
                                                    <p className="text-lg font-normal text-[#555259]">Shipping Address</p>
                                                    {addresses.length > 0
                                                        ? (
                                                            <>
                                                                {isLoaded && addresses.length > 0 && addresses.filter((addr1) => addr1.SITE_USE_CODE === 'SHIP_TO').map((item, i) => (
                                                                    <div className="rounded-[7px] bg-[#FFFFFF] px-7 pt-3 pb-3.5 mt-5" key={item.CUST_ACCOUNT_ID}>
                                                                        {/* <div className="flex justify-between">
                                                                            <p className="text-xs6 font-normal text-[#808285]">Office 2</p>
                                                                            <div>
                                                                                <p className="text-xs3 font-normal text-[#808285]">3PL Location</p>
                                                                                <div
                                                                                    className="dropdown relative"
                                                                                    onClick={() => {
                                                                                        if (isUpdate) {
                                                                                            if (ThreePlOpen === `${item?.THIRD_PARTY_LOGISTICS?.CITY}+${i}`) {
                                                                                                setThreePlOpen('');
                                                                                            } else {
                                                                                                setThreePlOpen(`${item?.THIRD_PARTY_LOGISTICS?.CITY}+${i}`);
                                                                                            }
                                                                                        }
                                                                                    }}
                                                                                >
                                                                                    <button type="button" id="dropdownMenucity" data-bs-toggle="dropdown" aria-expanded="false" className="customrotate">
                                                                                        <span className="text-xs6 font-bold text-[#090406] flex">
                                                                                            {' '}
                                                                                            {item.THIRD_PARTY_LOGISTICS?.CITY}
                                                                                            {' '}
                                                                                            <img src="/images/chevron-Up.svg" alt="icon" className="ml-1.5 default-dropdown transition-all duration-500" />
                                                                                        </span>
                                                                                    </button>
                                                                                    {ThreePlOpen !== '' && (
                                                                                        <ul
                                                                                            className={`dropdown-menu absolute ${ThreePlOpen === `${item.THIRD_PARTY_LOGISTICS.CITY}+${i}` ? 'show' : 'hidden'} bg-[#FFFFFF] rounded-lg min-w-[123px] max-w-[123px] shadow-s2 px-1 pt-1.5 pb-2`}
                                                                                            style={{ height: '150px', overflow: 'auto' }}
                                                                                            key={`pl-${item.CUST_ACCOUNT_ID}`}

                                                                                            aria-labelledby="dropdownMenucity"
                                                                                        >
                                                                                            <AnimatePresence>

                                                                                                {thriPL.length > 0 && thriPL.map((pl, key) => (
                                                                                                    <motion.li
                                                                                                        animate={{ opacity: 1, y: 0 }}
                                                                                                        initial={{ opacity: 0, y: 20 }}
                                                                                                        exit={{ opacity: 0, y: -20 }}
                                                                                                        transition={{ duration: 0.25 }}
                                                                                                        className={`bg-[#EBEBEB] rounded text-center ${key !== 0 ? 'mt-3.5' : ''}`}
                                                                                                        key={ThreePlOpen === `${item.THIRD_PARTY_LOGISTICS.CITY}+${i}`}
                                                                                                        onClick={() => HandleUpdate3pl(pl, i, item)}
                                                                                                    >
                                                                                                        <a className="dropdown-item text-xs2 font-normal text-[#090406] w-full inline-block" href="javascript:void(0)">{pl.DESCRIPTION}</a>
                                                                                                    </motion.li>
                                                                                                ))}
                                                                                            </AnimatePresence>

                                                                                        </ul>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </div> */}

                                                                        <p className="pt-4 text-xs6 font-normal text-[#090406]">
                                                                            {item.ADDRESS1}
                                                                            {' '}
                                                                            {item.ADDRESS2}
                                                                            ,
                                                                            <br />
                                                                            {' '}
                                                                            {item.ADDRESS3}
                                                                            {' '}
                                                                            {item.ADDRESS4}
                                                                            ,
                                                                            <br />
                                                                            {' '}
                                                                            {item.CITY}
                                                                            {' '}
                                                                            -
                                                                            {' '}
                                                                            {item.POSTAL_CODE}
                                                                            {' '}
                                                                            {item.STATE}
                                                                            ,
                                                                            {' '}
                                                                            {item.COUNTRY}
                                                                            <br />
                                                                            {' '}
                                                                            {item.LOCATION}
                                                                            ,
                                                                            <br />
                                                                            {' '}
                                                                            {item.ATTRIBUTE2}
                                                                        </p>
                                                                    </div>
                                                                ))}
                                                            </>
                                                        )
                                                        : <div className="pt-5 font-semi-bold text-lg">No Shipping Address Available</div>}
                                                </motion.div>
                                            </AnimatePresence>
                                        </div>
                                    </div>
                                </div>
                                <div className={`tab-pane fade ${TwoTabs === 'liasions' ? 'show active' : 'hidden'} pt-[30px] pb-[140px]`} id="pills-ador" role="tabpanel" aria-labelledby="pills-ador-tab">
                                    <>
                                        <AnimatePresence>
                                            <motion.div
                                                key={TwoTabs === 'address'}
                                                animate={{ opacity: 1, y: 0 }}
                                                initial={{ opacity: 0, y: 20 }}
                                                exit={{ opacity: 0, y: -20 }}
                                                transition={{ duration: 0.25 }}
                                            >
                                                { DistributorData.TEMP_SUPPORT && ['sales_head', 'regional_sales_manager', 'area_sales_manager', 'area_sales_engineer'].map((key, iindexKey) => (
                                                    <div>
                                                        <p className="text-lg font-semibold text-[#A1A1A1]">{['area_sales_engineer'].includes(key) ? capitalizeFirstLetter(key) : capitalizeFirstLetter(key).replace('Sales', 'Business')}</p>
                                                        <div className="flex -mx-4 justify-between flex-wrap pb-[10px]">
                                                            <>
                                                                {DistributorData.TEMP_SUPPORT && DistributorData.TEMP_SUPPORT[key].map((bh, i) => (
                                                                    <div className="px-4 w-1/2">
                                                                        <div className="mt-5 py-3 pl-3 pr-6 bg-[#FFFFFF] rounded-lg flex items-center justify-between">
                                                                            <div className="flex">
                                                                                <InitialIcon initials={InitialMaker(bh.FIRST_NAME, bh.LAST_NAME)} widthValue="47" heightValue="47" font="18" paddingValue={12} />
                                                                                <div className="px-3">
                                                                                    <p className="text-lg font-semibold text-[#090406]">
                                                                                        {bh.FIRST_NAME}
                                                                                        {' '}
                                                                                        {bh.LAST_NAME}
                                                                                    </p>
                                                                                    <p className="text-xs2 font-semibold text-[#A1A1A1]">{['area_sales_engineer'].includes(key) ? capitalizeFirstLetter(key) : capitalizeFirstLetter(key).replace('Sales', 'Business')}</p>
                                                                                    <p className="text-xs3 font-semibold text-[#A1A1A1]">
                                                                                        (
                                                                                        {bh.PRODUCT_CATEGORIES.join(',')}
                                                                                        )
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                            {isUpdate && (
                                                                                <img
                                                                                    src="/images/red-close-circle-outline.svg"
                                                                                    alt="icon"
                                                                                    className="cursor-pointer"
                                                                                    data-bs-toggle="modal"
                                                                                    data-bs-target="#removebh"
                                                                                    onClick={() => {
                                                                                        setModalType('remove');
                                                                                        setremoveParams({
                                                                                            type: ['area_sales_engineer'].includes(key) ? capitalizeFirstLetter(key) : capitalizeFirstLetter(key).replace('Sales', 'Business'),
                                                                                            shortcut: ['area_sales_engineer'].includes(key) ? capitalizeFirstChracter(key) : capitalizeFirstChracter(key).replace('S', 'B'),
                                                                                            item: bh,

                                                                                        });
                                                                                    }}
                                                                                />
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                                {isUpdate
                                                                && (
                                                                    <div className="px-4 w-1/2">
                                                                        <div className="mt-5 py-[22px] pl-6 bg-[#FFFFFF] rounded-lg flex items-center">
                                                                            <div className="flex">
                                                                                <button
                                                                                    type="button"
                                                                                    data-bs-toggle="modal"
                                                                                    data-bs-target="#modalbh"
                                                                                    onClick={() => {
                                                                                        setModalType('rolesModal');
                                                                                        setrolesParams({
                                                                                            type: key,
                                                                                            shortcut: ['area_sales_engineer'].includes(key) ? capitalizeFirstChracter(key) : capitalizeFirstChracter(key).replace('S', 'B'),
                                                                                            search: '',
                                                                                        });
                                                                                    }}
                                                                                >
                                                                                    <img src="/images/addmore.svg" alt="icon" className="cursor-pointer" />
                                                                                </button>
                                                                                <div className="pl-4">
                                                                                    <p className="text-lg font-semibold text-[#090406]">
                                                                                        Add new
                                                                                        {' '}
                                                                                        {['area_sales_engineer'].includes(key) ? capitalizeFirstChracter(key) : capitalizeFirstChracter(key).replace('S', 'B')}
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </>

                                                        </div>
                                                    </div>
                                                ))}
                                            </motion.div>
                                        </AnimatePresence>
                                    </>
                                </div>
                            </div>
                        </div>
                        <AnimatePresence>
                            <motion.div
                                key={isLoaded}
                                animate={{ opacity: 1, y: 0 }}
                                initial={{ opacity: 0, y: 20 }}
                                exit={{ opacity: 0, y: -20 }}
                                transition={{ duration: 0.15 }}
                                className="mt-10 ml-2.5 w-[30%] pt-5 px-3 pb-[30px] bg-[#F5F5FA] rounded-[7px]"
                            >
                                <div className="flex justify-between">
                                    <p className="text-xs11 font-semibold text-[#090406]">Privileges</p>
                                    {isUpdate && (
                                        <span className={isPrivilegesDirty && !loading ? '' : 'cursor-not-allowed'}>
                                            <button
                                                onClick={() => isPrivilegesDirty && !loading && HandleUpdate()}
                                                type="button"
                                                disabled={!isPrivilegesDirty || loading}
                                                className="h-[36px] w-[76px] text-center py-2 rounded bg-[#555259] text-base font-normal text-[#FFFFFF] save disabled:bg-[#D0D7E5] disabled:pointer-events-none flex justify-center items-center"
                                            >
                                                {loading ? <ThreeDotsLoader /> : 'Save'}
                                            </button>
                                        </span>
                                    )}
                                </div>
                                <div>
                                    <div className="flex mt-4">
                                        <span
                                            role="button"
                                            tabIndex={0}
                                            onClick={() => setPrivilegeTab('global')}
                                            className={`text-xs6 font-semibold mr-6 pb-2 border-b-2 cursor-pointer ${PrivilegeTab === 'global' ? 'text-[#090406] border-[#ED1C24]' : 'text-[#555259] border-[#FFFFFF]'}`}
                                        >
                                            Global
                                        </span>
                                        <span
                                            role="button"
                                            tabIndex={0}
                                            onClick={() => setPrivilegeTab('category')}
                                            className={`text-xs6 font-semibold pb-2 border-b-2 cursor-pointer ${PrivilegeTab === 'category' ? 'text-[#090406] border-[#ED1C24]' : 'text-[#555259] border-[#FFFFFF]'}`}
                                        >
                                            IWB/MnR
                                        </span>
                                    </div>
                                    {PrivilegeTab === 'global' && (
                                        <div>
                                            <div className="mt-[15px] px-[18px] py-1 bg-[#FFFFFF] rounded-[7px]">
                                                <p className="text-xs6 font-semibold text-[#555259]">Privilege</p>
                                            </div>
                                            {isLoaded && GlobalDistributorPrevileges.map((item, i) => (
                                                <div className="mt-[15px] px-[18px] py-3 bg-[#FFFFFF] rounded-[7px] flex items-center justify-between" key={item ?? i}>
                                                    <p className="text-xs6 font-normal text-[#090406]">{formatPrivilegeName(item)}</p>
                                                    <div
                                                        role="button"
                                                        tabIndex={isUpdate ? 0 : -1}
                                                        aria-label={`Toggle ${formatPrivilegeName(item)}`}
                                                        className={`switch switch-red ${isUpdate ? '' : 'switch-readonly'}`}
                                                        data-isOn={DistributorData.PRIVILAGES.includes(item)}
                                                        onClick={() => isUpdate && handleAddPrevilage(item, 'PRIVILAGES')}
                                                    >
                                                        <motion.div className="handle" layout transition={spring} />
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                    {PrivilegeTab === 'category' && (
                                        <div>
                                            <div className="mt-[15px] px-[18px] py-1 bg-[#FFFFFF] rounded-[7px] flex items-center justify-between">
                                                <p className="text-xs6 font-semibold text-[#555259] w-1/2">Privilege</p>
                                                <p className="text-xs6 font-semibold text-[#555259] w-1/4 text-center">IWB</p>
                                                <p className="text-xs6 font-semibold text-[#555259] w-1/4 text-center">MnR</p>
                                            </div>
                                            {isLoaded && CategoryDistributorPrevileges.map((item, i) => (
                                                <div className="mt-[15px] px-[18px] py-3 bg-[#FFFFFF] rounded-[7px] flex items-center justify-between" key={item ?? i}>
                                                    <p className="text-xs6 font-normal text-[#090406] w-1/2">{formatPrivilegeName(item)}</p>
                                                    {['IWB', 'MnR'].map((category) => {
                                                        const isChecked = DistributorData.CATEGORY_PRIVILAGES?.[category]?.includes(item) || false;
                                                        return (
                                                            <div key={category} className="w-1/4 flex justify-center">
                                                                <div
                                                                    role="button"
                                                                    tabIndex={isUpdate ? 0 : -1}
                                                                    aria-label={`Toggle ${formatPrivilegeName(item)} for ${category}`}
                                                                    className={`switch switch-red ${isUpdate ? '' : 'switch-readonly'}`}
                                                                    data-isOn={isChecked}
                                                                    onClick={() => isUpdate && handleToggleCategoryPrevilage(item, category)}
                                                                >
                                                                    <motion.div className="handle" layout transition={spring} />
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </motion.div>
                        </AnimatePresence>
                    </div>
                )}
            </div>
        </>
    );
}

export default ViewDistributor;
